module.exports = __webpack_public_path__ + "img/all-stations-bg.5e4c366a.jpg";